export default __webpack_public_path__ + "static/media/Run (7).40459d42.png";